<template>
  <v-container fluid>
    <v-card :loading="loading">
      <v-card-title>
        <h2>
          <v-btn depressed class="mx-2" icon text :to="{ name: 'tipo-proprietario-doc-list' }">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span v-if="loading">Carregando...</span>
          <span v-else>Alterar tipo de documento: {{proprietario.descricao}}</span>
        </h2>
      </v-card-title>
      <form @submit.prevent="submitForm">
        <v-card-text>
          <v-autocomplete
            v-model="proprietario.responsaveis"
            :items="usuarios"
            item-text="nome"
            item-value="id"
            label="Usuários que receberão alertas de vencimento de documentos"
            multiple
            chips
            deletable-chips
          >
            <template v-slot:item="{item}">
              <v-list-item-content>
                <v-list-item-subtitle>{{item.login}}</v-list-item-subtitle>
                <v-list-item-title>{{item.nome}}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn depressed color="primary" @click="submit" :loading="loading">Salvar</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      proprietario: {
        id: "",
        descricao: "",
        responsaveis: []
      }
    };
  },

  computed: {
    ...mapState({
      usuarios: state => state.usuarios.usuarios
    })
  },
  async mounted() {
    this.loading = true;
    try {
      const r = await Promise.all([
        this.$store.dispatch(
          "documento/carregarProprietario",
          this.$route.params.id
        ),
        this.$store.dispatch("usuarios/listar", {
          filtros: { ativo: true }
        })
      ]);
      this.proprietario = r[0];
      this.proprietario.responsaveis = this.proprietario.responsaveis.map(
        r => r.id_usuario
      );
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        const id_tipo_proprietario = this.proprietario.id;
        await this.$store.dispatch("documento/gravarProprietario", {
          id: id_tipo_proprietario,
          responsaveis: this.proprietario.responsaveis.map(resp => ({
            id_usuario: resp,
            id_tipo_proprietario
          }))
        });
        this.$router.replace({ name: "tipo-proprietario-doc-list" });
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível salvar o tipo de proprietario."
        });
      }
    }
  }
};
</script>
